var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'botao-padrao',
    { 'arredondado-esquerda': _vm.arredondadoEsquerda },
    { 'arredondado-direita': _vm.arredondadoDireita },
    { desabilita: _vm.desabilita },
    _vm.cor ? _vm.cor : ''
  ],style:(_vm.padding ? ("padding: 0 " + _vm.padding + "px") : ''),attrs:{"disabled":_vm.desabilita}},[(_vm.loading)?_c('div',{class:['loading-icone', 'botao-icone', _vm.tamanho ? '' : 'icone-tamanho'],style:(_vm.tamanho ? ("font-size: " + _vm.tamanho + "px;") : '')},[_c('i',{staticClass:"fas fa-spinner fa-spin"})]):_c('font-awesome-icon',{class:['botao-icone', _vm.tamanho ? '' : 'icone-tamanho'],style:(_vm.tamanho ? ("font-size: " + _vm.tamanho + "px;") : ''),attrs:{"icon":_vm.icone}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }